import React, { useEffect, useState, useContext, use } from 'react'
import { FetchData, useFetch } from '../../api/FetchApiData';
import './cat-form.css';
import { isMobile } from 'react-device-detect';
import { TeachButton } from '../../utils/Loaders/ButtonLoader';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../AppContextProvider';
import { useTranslation } from 'react-i18next';
if (isMobile)
    import('./mob-cat-form.css').then(() => {});
else
    import('./cat-form.css').then(() => {});


function CategoryForm({close=()=>{}, action,category={name:'',id: null,characteristics:[],dimensionnements:[]},rayon, setRayons}) {
    const [_category,setCategory] = useState(category);
    const fectch = useFetch();
    const [notification,setNotification] = useState({text:'',color:'black'});
    const [AppState, setAppState] = useContext(AppContext);
    const [_lang, set_lang] = useState(AppState.settings.lang);
    const {t} = useTranslation();
    const navigator = useNavigate();
    useEffect(()=>{
        if(action==="Modifier")
        {setCategory({...category});}
    },[category])

    useEffect(()=>{
        set_lang(AppState.settings.lang);
    },[AppState.settings.lang])


    const Updata_Data = (close)=>
    {
        if(!!_category.id)
        {
            const _category_ = {..._category};
            console.log(_category_);
            fectch.PutData(_category_,'category/').then((result)=>{
                if(result.result)
                {
                    setNotification({text:"Categorie mise à jour", color:'green'});
                    setTimeout(()=>{setNotification({text:'',color:'black'});close();setRayons([...result.rayons])},3000);
                }
                else
                {
                    setNotification({text:result.errors[0],color:'red'});
                    setTimeout(()=>{setNotification({text:'',color:'black'});},3000);
                }
            });
        }
    }

    const Delete_Data = (close)=>{
    }

    const Delete_Characteristic = (id,index)=>{
        fectch.DeleteData({id:id},'category-characteristic/').then((result)=>{
            //console.log(result);
            if(result.result)
            {
                _category.characteristics.splice(index,1);
                setCategory({..._category});
                setNotification({text:"supprimé(e)", color:'green'});
                setTimeout(()=>{setNotification({text:'',color:'black'});setRayons([...result.rayons])},3000);
            }
            else
            {
                setNotification({text:"Erreur de suppression",color:'red'});
                setTimeout(()=>{setNotification({text:'',color:'black'});},3000);
            }});
    }

    const Delete_Dimensionnement = (id,index)=>{
        fectch.DeleteData({id:id},'category-dimensionnement/').then((result)=>{
            console.log(result);
            if(result.result)
            {
                _category.dimensionnements.splice(index,1);
                setCategory({..._category});
                setNotification({text:"supprimé(e)", color:'green'});
                setTimeout(()=>{setNotification({text:'',color:'black'});setRayons([...result.rayons])},3000);
            }
            else
            {
                setNotification({text:result.errors[0],color:'red'});
                setTimeout(()=>{setNotification({text:'',color:'black'});},3000);
            }});
    }

    const ExecAction = (close)=>
    {
        if(action==="Modifier")
        {Updata_Data(close);}
        else
            Delete_Data(close);
    }

    let trigger_color = (action==="Supprimer") ? '#FFCCCB' : 'lightgreen';
    trigger_color = (action==="Modifier") ? 'lightblue' : trigger_color; 

    const Form = (close)=>
    {
        if(action==="Nouveau" || action==="Modifier")
        {
            return(
            <>
                <div style={{textAlign:'center'}} className='cat-div-input'>
                    <p style={{color:notification.color}}>{notification.text}</p>
                </div>
                <div  className="cat-div-input">
                    <label className='cat-label' >{t('filters.rayon')} </label>
                    <input style={{border:'1px solid lightgray'}} disabled type='text' value={rayon.name} className='cat-user-input' />
                </div>
                <div className="cat-div-input">
                    <label className='cat-label'>{t('authentication.nom')} </label>
                    <input onChange={(e)=>{setCategory({..._category,name:e.target.value})}} type='text' style={{border:'1px solid lightgray'}} value={_category.name} className='cat-user-input' />
                </div>
                <div className="cat-div-input">
                    <label className='cat-label'>{t('filters.caracteristiques')} </label>
                    <div className='cat-car-div'>
                        {
                            _category.characteristics.map((car,index)=>{
                                return(
                                    <div style={{width:'100%',marginTop:'5px'}}>
                                        <input className='cat-car-input' name={index.toString()} placeholder = 'name' value={_category.characteristics[index].name}  onChange={e=>{_category.characteristics[index].name = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input className='cat-car-input' name={index.toString()} placeholder ={t('ajout-produit.default-value')} value={_category.characteristics[index].default_value}  onChange={e=>{_category.characteristics[index].default_value = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input onClick={e=>{Delete_Characteristic(car.id,index);}} name={index.toString()} style={{backgroundColor:'#FFCBCC',margin:'2px',borderRadius:'5px',border:'none',width:'22%',display:'inline-block',height:'35px',padding:'0px 10px 0px 10px',margin:'0px',fontSize:'x-small'}} type='button' value={t("ajout-produit.supprimer")} />
                                    </div>)
                            })
                        }
                        {(AppState.settings.lang === 'fr') && (
                            <input onClick={e=>{category.characteristics.push({name:'name',default_value: 'default value'});setCategory({...category})}} type='button' value={'Ajouter'} style={{margin:'10px',width:'70%',height:'35px',borderRadius:'5px',backgroundColor:'whitesmoke'}} />
                        )}
                        {(AppState.settings.lang !== 'fr') && (
                            <span style={{color:'orangered',fontSize:'x-small'}}>{t("ajout-produit.lang-ajout-car")}</span>
                        )}
                    </div>
                </div>
                <div className="cat-div-input">
                    <label className='cat-label'>{t('filters.dimensionnement')} </label>
                    <div className='cat-car-div'>
                        {
                            _category.dimensionnements.map((car,index)=>{
                                return(
                                    <div style={{width:'100%',marginTop:'5px'}}>
                                        <input className='dim-input' name={index.toString()} placeholder = 'name' value={_category.dimensionnements[index].name}  onChange={e=>{_category.dimensionnements[index].name = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input className='dim-input' name={index.toString()} placeholder = 'default value' value={_category.dimensionnements[index].value}  onChange={e=>{_category.dimensionnements[index].value = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input className='dim-input' name={index.toString()} placeholder = 'unite' value={_category.dimensionnements[index].unite}  onChange={e=>{_category.dimensionnements[index].unite = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input onClick={e=>{Delete_Dimensionnement(car.id,index)}} name={index.toString()} style={{backgroundColor:'#FFCBCC',margin:'2px',borderRadius:'5px',border:'none',width:'22%',display:'inline-block',height:'35px',padding:'0px 10px 0px 10px',margin:'0px',fontSize:'x-small'}} type='button' value={t("ajout-produit.supprimer")} />
                                    </div>)
                            })
                        }
                        {(AppState.settings.lang === 'fr') && (
                            <input onClick={e=>{category.dimensionnements.push({name:'name',value: 'value',unite:'unite'});setCategory({...category})}} type='button' value={'Ajouter'} style={{margin:'10px',width:'70%',height:'35px',borderRadius:'5px',backgroundColor:'whitesmoke'}} />
                        )}
                        {(AppState.settings.lang !== 'fr') && (
                            <span style={{color:'orangered',fontSize:'x-small'}}>{t('ajout-produit.lang-ajout-dim')}</span>
                        )}
                        </div>
                </div>
                <div style={{textAlign:'center'}} className='cat-div-input'>
                    <input onClick={e=>{ExecAction(close);}} style={{margin:'10px',fontSize:'small',height:'30px',minWidth:'20%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:trigger_color}} type='button' value={t("user-info.enregistrer")} />
                    <input onClick={close} style={{margin:'10px',height:'30px',minWidth:'20%',fontSize:'small',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'orangered'}} type='button' value={t("ajout-produit.annuler")} />
                    {
                      //<TeachButton id={category.id} target={'category'} width={'50%'} />
                    }
                </div>
            </>);
        }
    }

    if(category.id===null || category.id===undefined)
        return(
        <div style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px',width:'100%',height:'100vh'}}>
            <fieldset className='cat-fieldset'>
                <label style={{color:'orangered'}}>Aucune categorie sélectionnée</label><br/>
                <input type='button' style={{height:'25px',padding:'5px 20px 5px 20px',marginTop:'10px'}} value={'OK'} onClick={e=>{close()}} />
            </fieldset>
        </div>
        );

    if(rayon.id==='' || rayon.id===null || rayon.id===undefined)
        return(
        <div style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px',width:'100%',height:'100vh'}}>
            <fieldset className='cat-fieldset'>
                <label style={{color:'orangered'}}>Aucun rayon n'a été sélectionné</label><br/>
                <input type='button' style={{height:'25px',padding:'5px 20px 5px 20px',marginTop:'10px'}} value={'OK'} onClick={e=>{close()}} />
            </fieldset>
        </div>
        );

  return (
    <div style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px',width:'100%',height:'100vh'}}>
        <fieldset className='cat-fieldset'>
            {Form(close)}
        </fieldset>
    </div>)
}

export default CategoryForm;
